export default __webpack_public_path__ + "0ff342310e04485a286e8117fc922339.svg";